module.exports = __webpack_public_path__ + "img/img-1.1302ebdf.jpg";